export const onlyNumericalHandler = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(/[^0-9]/g, "");
};
export const onlyLatinAlphabeticalHandler = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const regex = /[A-Za-z0-9!@#$.%^&*()_|}{~">:<?/\][\\=\- ]/g;
  let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

export const onlyAlphabeticalHandler = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const regex = /[A-Za-zА-Яа-я/\u0530-\u058F/-\s]/gi;
  let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

export const withoutArmenianCharactersHandler = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const regex = /[A-Za-zА-Яа-я0-9!@#$.%^&*()_|}{~">:<?/\][\\=\- ]/g;
  let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

export const onlyArmenianWithCharactersHandler = (
  event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement> | any
) => {
  const regex = /[Ա-Ֆա-ֆ0-9!@.#$%^&*()_|}{~">:<?/\][\\=\- ]/g;
  let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

export const armenianAndLatinWithCharacters = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const regex = /[A-Za-zԱ-Ֆա-ֆ0-9!@.#$%^&*()_|}{~">:<?/\][\\=\- ]/g;
  let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

export const charactersForBuildingApartment = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const regex = /[A-Za-zԱ-Ֆա-ֆА-Яа-я0-9!@.#$%^&*()_|}{~">:<?/\][\\=\- ]/g;
  let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
};

export const onlyApartmentValidationHandler = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  event.target.value = event.target.value.replace(/[^0-9]/g, "");
};

export const onPasteHandlerForForeignCountries = (
  event: any,
  type: string,
  watch: any,
  setError: any
) => {
  const regex =
    watch("recipientCountry.id") === 533
      ? /[A-Za-zА-Яа-я0-9]/gi
      : /[A-Za-z0-9]/gi;
  if (!regex.test(event.clipboardData.getData("Text"))) {
    setError(`${type}`, {
      type: "manual",
      message:
        watch("recipientCountry.id") !== 533
          ? "Մուտքագրեք միայն լատինատառ"
          : "Մուտքագրեք ռուսերեն կամ լատինատառ",
    });
    event.preventDefault();
    return false;
  }
};

export const onPasteHandlerForLocalCountries = (
  event: any,
  type: string,
  setError: any
) => {
  const regex = /[Ա-Ֆա-ֆ0-9!@.#$%^&*()_|}{~">:<?/\][\\=\- ]/g;
  if (!regex.test(event.clipboardData.getData("Text"))) {
    setError(`${type}`, {
      type: "manual",
      message: "Մուտքագրեք միայն հայատառ",
    });
    event.preventDefault();
    return false;
  }
};
